import { makeStyles } from "@mui/styles"
import { defaultTo } from "ramda"

export const useStyles = makeStyles(({ skinObject, typography }) => {
  const defaultSkinObject = { link: { color: "#756372" } },
    breadcrumbsSkins = defaultTo(defaultSkinObject, skinObject && skinObject.breadcrumbs),
    { color } = breadcrumbsSkins.link

  return {
    root: {
      letterSpacing: "initial",
      "& p": {
        letterSpacing: "initial",
      },
    },

    container: {
      display: "flex",
      marginBottom: "15px",

      "@media print": {
        display: "none",
      },
    },

    current: {
      "&.MuiTypography-root": {
        fontSize: typography.pxToRem(11),
      },
      "&:hover": {
        textDecoration: "none !important",
      },
      color,
      fontWeight: "bold !important",
      pointerEvents: "none",
    },

    icon: {
      "&.MuiIcon-root": {
        fontSize: typography.pxToRem(15),
        height: typography.pxToRem(15),
        width: typography.pxToRem(15),
      },
      "&:hover": {
        textDecoration: "underline",
      },
    },

    link: {
      "&.MuiLink-root": {
        color,
        fontSize: typography.pxToRem(11),
      },
      "&:hover, &:focus": {
        color,
        cursor: "pointer",
        textDecoration: "underline !important",
      },
      color,
      display: "flex",
    },

    separator: {
      fontSize: typography.pxToRem(11),
    },
  }
})
